import { Component, input, output } from '@angular/core';
import { LineInputs } from '@charts';
import { LineChartComponent } from '../line-chart';
import { ChartOptions } from 'chart.js';

@Component({
  selector: 'ui-rsabt-intensity-chart',
  imports: [LineChartComponent],
  template: `
    <ui-line-chart
      [options]="options()"
      [lineInputs]="lineInputs()"
      (changeVisibility)="changeVisibility.emit($event)"
    />
  `,
})
export class RsabtIntensityChartComponent {
  options = input<ChartOptions<'line'>>();
  lineInputs = input.required<LineInputs>();
  changeVisibility = output<any>();
}
